import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { AddCustomContent } from "domains/customContentAndSources/components/AddCustomContent";
import { getIsNewCustomContent } from "domains/customContentAndSources/selectors";
import { ModalHeader } from "domains/modal/components/ModalHeader";

export const AddCustomContentModal = () => {
  const translate = useTranslate();
  const isNewCustomContent = useSelector(getIsNewCustomContent);

  const title = isNewCustomContent
    ? "app.custom_attachment.section.add.title"
    : "app.custom_attachment.section.edit.title";

  return (
    <>
      <ModalHeader title={translate(title)} />
      <AddCustomContent />
    </>
  );
};
